var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSection',{attrs:{"id":"invoice-details","type":"page","title":_vm.$getConst.pages.invoice_details.page_title}},[(_vm.invoice)?_c('InvoiceDetails',{attrs:{"invoice":_vm.invoice,"is-loading":_vm.isLoading}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }